/* eslint-disable @typescript-eslint/no-explicit-any */
import Qs from 'qs'
import service from '@/services/service'
const resource = {
    main: 'services',
    module: 'one-shot-whitelists'
}

export class WhitelistOneShotServices {
    public static getWhitelistOneShot () {
        return service.get(`${resource.main}/${resource.module}`)
    }

    public static getWhitelistOneShotPaginate (params: object) {
        return service.get(`${resource.main}/${resource.module}/paginate`, {
            params,
            paramsSerializer: (params) => {
                return Qs.stringify(params, { arrayFormat: 'indices' })
            }
        })
    }

    public static importWhitelistOneShot (params: {uploadfile: File}) {
        const form = new FormData()
        form.append('uploadfile', params.uploadfile)
        return service.post(`${resource.main}/${resource.module}/upload/add`, form, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

    public static removeWhitelistOneShot (params: {uploadfile: File}) {
        const form = new FormData()
        if (params.uploadfile) {
            form.append('uploadfile', params.uploadfile)
        }
        return service.put(`${resource.main}/${resource.module}/upload/remove`, form, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

    public static getWhiteListOneShotFileById () {
        return service.get(`${resource.main}/${resource.module}/export/`, {
            responseType: 'arraybuffer'
        })
    }

    public static deleteWhitelistOneShot (id: number) {
        return service.delete(`${resource.main}/${resource.module}/${id}`)
    }
}
